import instance from "api/globalaxios";

// Existing API exports from OrixApi.js
export async function download_MIS_Report(startDate, endDate) {
  return instance({
    method: 'get',
    url: `api/orixmisreport/?` + ((startDate && endDate) ? `start_date=${startDate}&end_date=${endDate}` : ''),
    responseType: 'blob'
  })
}

export async function triggerOrixEmail(type, email='') {
  return instance({
    method: 'post',
    url: `api/trigger_orix_email/?type=${type}&email=${email}`,
  })
}

// API helpers from DisputeDetailsOrix.js
export async function getClaimantAnswerData(id) {
  return await instance({
    method: "get",
    url: "/claimantanswerdata/" + id + "/",
  });
}

export async function getCaseTimeline(id) {
  return await instance({
    method: "get",
    url: `api/timeline/?id=${id}`,
  });
}

export async function markDisputeAsSeen(id) {
  return await instance({
    method: "put",
    url: `api/read/dispute-status/${id}/`,
  });
}

export async function getReasonsForRejection() {
  return await instance({
    method: "get",
    url: "/get-rejection-values/",
  });
}
